<template>
  <div>
    <el-form
      ref="form"
      :model="formData"
      :rules="rules"
      :disabled="disabled"
      size="mini"
    >
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item
            :label="$l('form_label_dfDefinitionName') || '标准名称'"
            prop="dfDefinitionName"
          >
            <el-input
              v-model="formData.dfDefinitionName"
              :placeholder="
                $l('form_label_pl_dfDefinitionName') || '请输入标准名称'
              "
              :maxlength="500"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            :label="$l('form_label_custName') || '适用客户'"
            prop="customerCode"
          >
            <el-select
              v-model="formData.customerCode"
              :placeholder="$l('form_label_pl_custName') || '请选择适用客户'"
              filterable
              clearable
              style="width:100%"
            >
              <el-option
                v-for="item in customerOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="16">
          <el-form-item
            :label="$l('form_label_productScopeDescription') || '适用产品说明'"
            prop="productScopeDescription"
          >
            <el-input
              v-model="formData.productScopeDescription"
              :placeholder="
                $l('form_label_pl_productScopeDescription') ||
                  '请输入适用产品说明'
              "
              :maxlength="50"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item :label="$l('form_label_enableDate') || '启用日期'">
            <el-date-picker
              v-model="formData.enableDate"
              value-format="yyyy-MM-dd"
              type="date"
              style="width: 100%"
              disabled
            />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item :label="$l('form_label_disableDate') || '停用日期'">
            <el-date-picker
              v-model="formData.disableDate"
              value-format="yyyy-MM-dd"
              type="date"
              style="width: 100%"
              disabled
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item
            :label="$l('form_label_useDescription') || '标准使用说明'"
            prop="useDescription"
          >
            <Editor
              style="margin-top: 30px !important"
              v-model="formData.useDescription"
              :disabled="disabled"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item
            :label="$l('form_label_datermineDescription') || '疵点判定说明'"
            prop="datermineDescription"
          >
            <Editor
              style="margin-top: 30px !important"
              v-model="formData.datermineDescription"
              :disabled="disabled"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
import { request } from '@/api/service'
import Editor from '@/views/factory/components/editor'

export default {
  mixins: [EditLoading],
  components: {
    Editor,
  },
  props: {
    disabled: { type: Boolean, default: true },
    dfDefinitionCode: { type: String, default: '' },
  },
  data() {
    return {
      formData: {},
      customerOptions: [],
      rules: {
        dfDefinitionName: [
          {
            required: true,
            message:
              this.$l('form_label_pl_dfDefinitionName') || '请输入标准名称',
            trigger: 'change',
          },
        ],
        customerCode: [
          {
            required: true,
            message: this.$l('form_label_pl_custName') || '请选择适用客户',
            trigger: 'change',
          },
        ],
        productScopeDescription: [
          {
            required: true,
            message:
              this.$l('form_label_pl_productScopeDescription') ||
              '请输入适用产品说明',
            trigger: 'change',
          },
        ],
        useDescription: [
          {
            required: true,
            message:
              this.$l('form_label_pl_useDescription') || '请输入标准使用说明',
            trigger: 'change',
          },
        ],
        datermineDescription: [
          {
            required: true,
            message:
              this.$l('form_label_pl_datermineDescription') ||
              '请输入疵点判定说明',
            trigger: 'blur',
          },
        ],
      },
    }
  },
  computed: {
    ...mapState('admin/user', { userInfo: 'info' }),
    canDelete() {
      return this.listPacking.length > 1
    },
    evgPackingSchemeParams() {
      const { platformCode, custCode } = this.formData
      return { platformCode: platformCode || 'platformCode', custCode }
    },
    listEvgPackingSchemeCode() {
      const codes = this.listPacking
        .map((item) => item.evgPackingSchemeCode)
        .filter(Boolean)
      return [...new Set(codes || [])]
    },
  },
  // watch: {
  //   userInfo: {
  //     handler() {
  //       if (this.amzExpenseCode) return
  //       if (!this.userInfo) return
  //       const { userCode, userName, userNameEn } = this.userInfo
  //       this.formData.salesPersonCode = userCode || ''
  //       this.formData.salesPersonName = [userNameEn, userName]
  //         .filter(Boolean)
  //         .join('-')
  //     },
  //     immediate: true,
  //   },
  // },
  mounted() {
    this.getData()
    this.getCust()
  },
  methods: {
    async getData() {
      if (!this.dfDefinitionCode) return
      const data = await this.$api
        .dfDefinitionDetailApi({ dfDefinitionCode: this.dfDefinitionCode })
        .then((res) => res.body || {})
        .catch(() => ({}))
      this.formData = { ...data }
      this.$emit('loaded', data)
    },
    getCust() {
      //客户
      request({
        url: '/digitalCenter/common/dict/customer',
        method: 'post',
        data: {},
      }).then((res) => {
        this.customerOptions = res.body.data
        if (this.customerOptions) {
          this.customerOptions.splice(0, 0, { label: 'ALL', value: 'ALL' })
        } else {
          this.customerOptions = [{ label: 'ALL', value: 'ALL' }]
        }
      })
    },

    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return

      if (this.loadingOpen()) return
      const res = await this.$api
        .dfDefinitionSaveApi({
          ...this.formData,
        })
        .catch(() => null)
      this.loadingClose()
      if (!res) return
      const { status, body } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_save_ok') || '保存成功！',
        type: 'success',
      })

      if (this.dfDefinitionCode) return this.getData()

      const { dfDefinitionCode, dfDefinitionNo } = body
      this.$router.replace({
        name: 'inspection-defects-detail',
        params: { code: dfDefinitionCode, pageType: 'edit' },
        query: { dfDefinitionNo },
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.packing-form {
  background-color: #f4f6f9;
  padding: 16px;
  padding-bottom: 6px;
  border-radius: 5px;
  margin-bottom: 16px;
  .tool-btn {
    font-size: 22px;
  }
}
::v-deep {
  .packing-form {
    .el-input.is-disabled .el-input__inner,
    .el-textarea.is-disabled .el-textarea__inner {
      color: #606266 !important;
      background-color: #fff !important;
      border: 1px solid #dcdfe6 !important;
    }
  }
}
</style>
